"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _Auth = _interopRequireDefault(require("composer-lib/data/model/Auth"));

var _Composition = _interopRequireDefault(require("composer-lib/data/model/Composition"));

var _reactRedux = require("react-redux");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _userSettings = require("ComposeUI/redux/actions/userSettings");

var _Presence = _interopRequireDefault(require("composer-lib/data/model/Presence"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _ReadOnlyTooltip = _interopRequireDefault(require("ComposeUI/components/ReadOnlyTooltip"));

var _UIAlert = _interopRequireDefault(require("UIComponents/alert/UIAlert"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _Users = _interopRequireDefault(require("composer-lib/data/model/Users"));

var _UserSettings = _interopRequireDefault(require("ComposeUI/data/model/UserSettings"));

var mapStateToProps = function mapStateToProps(state) {
  return {
    auth: state.auth,
    composition: state.composition,
    presence: state.presence,
    users: state.users
  };
};

var ReadOnlyContainer = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ReadOnlyContainer, _Component);

  function ReadOnlyContainer(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ReadOnlyContainer);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ReadOnlyContainer).call(this, props));

    _this.handleReadOnlyDismiss = function () {
      var _this$props = _this.props,
          auth = _this$props.auth,
          userSettings = _this$props.userSettings;
      (0, _userSettings.markSeenReadOnlyAlert)(auth.user.get('user_id'), userSettings.toJS());

      _this.setState({
        readOnlyAlertOpen: false
      });
    };

    _this.state = {
      readOnlyAlertOpen: props.composition.isReadOnly()
    };
    return _this;
  }

  (0, _createClass2.default)(ReadOnlyContainer, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (!this.props.composition.isReadOnly() && nextProps.composition.isReadOnly()) {
        this.setState({
          readOnlyAlertOpen: true
        });
      }
    }
  }, {
    key: "renderReadOnlyAlert",
    value: function renderReadOnlyAlert() {
      var userSettings = this.props.userSettings;
      var seenReadOnlyAlert = userSettings.seenReadOnlyAlert || false;

      if (seenReadOnlyAlert || !this.state.readOnlyAlertOpen) {
        return null;
      }

      var titleText = _react.default.createElement("span", {
        className: "read-only-alert-title"
      }, _react.default.createElement(_UIIcon.default, {
        className: "m-right-3",
        name: "view",
        size: 22
      }), _react.default.createElement(_FormattedMessage.default, {
        message: 'composer-lib.alerts.readOnlyAlert.title'
      }));

      return _react.default.createElement(_UIAlert.default, {
        className: "read-only-alert",
        closeable: true,
        onClose: this.handleReadOnlyDismiss,
        titleText: titleText,
        type: "info"
      }, _react.default.createElement(_FormattedMessage.default, {
        className: "display-inline-block",
        message: 'composer-lib.alerts.readOnlyAlert.body'
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          composition = _this$props2.composition,
          presence = _this$props2.presence,
          users = _this$props2.users;
      return _react.default.createElement("div", {
        className: "read-only-container"
      }, _react.default.createElement(_ReadOnlyTooltip.default, {
        centered: true,
        composition: composition,
        presence: presence,
        showReadOnlyMode: composition.isReadOnly(),
        users: users
      }), this.renderReadOnlyAlert());
    }
  }]);
  return ReadOnlyContainer;
}(_react.Component);

ReadOnlyContainer.propTypes = {
  auth: _propTypes.default.instanceOf(_Auth.default).isRequired,
  composition: _propTypes.default.instanceOf(_Composition.default).isRequired,
  presence: _propTypes.default.instanceOf(_Presence.default).isRequired,
  users: _propTypes.default.instanceOf(_Users.default).isRequired,
  userSettings: _propTypes.default.instanceOf(_UserSettings.default).isRequired
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(ReadOnlyContainer);

exports.default = _default;
module.exports = exports.default;